export default __webpack_public_path__ + "static/media/floaters@2x.68784e3e.png";